var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongDingyuechenggong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14h-.5a.5.5 0 00.724.447L3 14zm10 0l-.224.447A.5.5 0 0013.5 14H13zm-5-2.5l.224-.447L8 10.94l-.224.112L8 11.5zM3.5 14V2.5h-1V14h1zm0-11.5h9v-1h-9v1zm9 0V14h1V2.5h-1zm.724 11.053l-5-2.5-.448.894 5 2.5.448-.894zm-5.448-2.5l-5 2.5.448.894 5-2.5-.448-.894zM12.5 2.5h1a1 1 0 00-1-1v1zm-9 0v-1a1 1 0 00-1 1h1z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7l1.5 1.5 3-3",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_dingyuechenggong.b4c63d06.svg";
export { SvgTongyongDingyuechenggong as ReactComponent };